// src/components/Header.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout } = useAuth(); // Utiliser le contexte
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login"); // Redirige vers la page de connexion après la déconnexion
  };

  return (
    <header className="relative flex flex-wrap sm:justify-around sm:flex-nowrap w-full bg-white text-sm py-3 border-b min-h-[65px]">
      <nav className="max-w-[85rem] w-full px-4 sm:flex sm:items-center sm:justify-between">
        <div className="flex items-center justify-between">
          <a
            className="flex-none text-xl font-semibold focus:outline-none focus:opacity-80"
            href="/login"
            aria-label="Brand"
          >
            DIGIS ASSUR
          </a>
          <div className="sm:hidden">
            <button
              type="button"
              className="hs-collapse-toggle relative size-7 flex justify-center items-center gap-x-2 rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-expanded={isMenuOpen}
              aria-controls="hs-navbar-example"
              aria-label="Toggle navigation"
            >
              {isMenuOpen ? (
                <svg
                  className="hs-collapse-open:block hidden shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              ) : (
                <svg
                  className="hs-collapse-open:hidden shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="3" x2="21" y1="6" y2="6" />
                  <line x1="3" x2="21" y1="12" y2="12" />
                  <line x1="3" x2="21" y1="18" y2="18" />
                </svg>
              )}
              <span className="sr-only">Toggle navigation</span>
            </button>
          </div>
        </div>
        <div
          id="hs-navbar-example"
          className={`hs-collapse overflow-hidden transition-all duration-300 basis-full grow sm:block ${
            isMenuOpen ? "block" : "hidden"
          }`}
          aria-labelledby="hs-navbar-example-collapse"
        >
          <div className="flex flex-col gap-5 mt-5 sm:flex-row sm:items-center sm:justify-end sm:mt-0 sm:ps-5">
            <a
              className="font-medium text-[#A1409D] focus:outline-none"
              href="https://www.digis-assur.net/"
              aria-current="page"
            >
              Une question ?
            </a>
            <a
              className="font-medium text-gray-600 hover:text-gray-400 focus:outline-none focus:text-gray-400"
              href="https://www.digis-assur.net/"
            >
              Contactez-nous
            </a>
            {user ? (
              <button
                onClick={handleLogout}
                className="font-medium text-gray-600 hover:text-gray-400 focus:outline-none focus:text-gray-400"
              >
                Se déconnecter
              </button>
            ) : (
              <a
                className="font-medium text-gray-600 hover:text-gray-400 focus:outline-none focus:text-gray-400"
                href="/login"
              >
                Se connecter
              </a>
            )}
            {/* <a className="font-medium text-gray-600 hover:text-gray-400 focus:outline-none focus:text-gray-400" href="https://www.digis-assur.cd/contact.html">
              FR/EN
            </a> */}
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
